export default __webpack_public_path__ + "static/career-hero-desktop-36dc32859f3d2023ac7309c7a6becfcc.png";